import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  IDownloadReportLinkResponse,
  IDownloadReportPayload,
} from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  DOWNLOAD_REPORT_LINK_MUTATION_KEY,
  DOWNLOAD_REPORT_LINK_URL,
  DOWNLOAD_REPORT_PERMISSIONS,
} from '../constants';

export default function useDownloadReportLinkMutation(): IContextMutationResult<
  IDownloadReportLinkResponse,
  Error,
  IDownloadReportPayload
> {
  const { fetchGet } = useRestClient();

  return useContextMutation<IDownloadReportLinkResponse, Error, IDownloadReportPayload>({
    mutationKey: [DOWNLOAD_REPORT_LINK_MUTATION_KEY],
    mutationFn: ({ id, format }) => fetchGet<IDownloadReportLinkResponse>(
      DOWNLOAD_REPORT_LINK_URL,
      {
        permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
        urlParams: {
          id,
        },
        queryParams: {
          format,
        },
      },
    ),
  });
}
